import * as React from "react";
import HeaderBackButtonCoin from "../components/HeaderBackbuttonCoin";
import { useLocation, useNavigate, useParams } from "react-router";
import {
  Avatar,
  Badge,
  Box,
  Container,
  Divider,
  Grid,
  IconButton,
  Stack,
  Typography,
} from "@mui/joy";
import { CryptoCurrencyFormat, CurrencyFormat } from "../config/services";
import { CallMadeOutlined, CallReceivedOutlined, SwapHoriz } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { collection, orderBy, query, where } from "firebase/firestore";
import { db } from "../config/firebase";
import { useFirestoreQuery } from "@react-query-firebase/firestore";
import { HistoryItem } from "../components/HistoryItem";
import { NoTransaction } from "./notification";

export function Activity({ code }) {
  const userinfo = useSelector((state) => state.useInfos);
  const { id } = userinfo;

  React.useEffect(() => {
    console.log(code);
  });

  const ref = query(
    collection(db, "users", id, "transactions"),
    where("cointitle", "==", code),
    orderBy("timestamp", "desc")
  );
  const querY = useFirestoreQuery(code, ref);

  if (querY.isLoading) {
    return <Typography>Loading...</Typography>;
  }

  const snapshot = querY.data;

  const switchImage = (key) => {
    switch (key) {
      case "BTC":
        return "../images/coins/btc.png";
      case "ETH":
        return "../images/coins/eth.png";
      case "BNB":
        return "../images/coins/eth.png";
      case "TRX":
        return "../images/coins/tron.png";
      case "USDT":
        return "../images/coins/usdt.png";
      default:
        return "../images/coins/usdt.png";
    }
  };

  let datalength = snapshot.docs.length;
  if (datalength > 0) {
    return snapshot.docs.map((docSnapshot, index) => {
      const data = docSnapshot.data();
      const { transaction_type, cointitle } = data;

      const isCredit = transaction_type === "Credit";

      return (
        <HistoryItem
          key={index}
          data={data}
          itemCode={
            isCredit ? "images/call-received@2x.png" : "images/call-made@2x.png"
          }
          id={docSnapshot.id}
          imageCode={switchImage(cointitle)}
          frameBorder={isCredit ? "1px solid green" : "1px solid #8a919e"}
        />
      );
    });
  }

  return <NoTransaction />;
}

export default function CoinDetail() {
  const navigate = useNavigate();
  let { state } = useLocation();

  let { image, thumbimage, code, balance, balancecoin } = state.coin;

  return (
    <>
      <HeaderBackButtonCoin image={image} title={code} />
      <Container maxWidth="md">
        <Grid
          container
          direction="column"
          spacing={2}
          sx={{ flexGrow: 1 }}
          mt={2}
          alignItems="center"
          justifyContent="stretch"
        >
          <Grid>
            <Stack spacing={1} direction="column" alignItems="center">
              <Badge
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                variant="plain"
                badgeContent={
                  <Avatar
                    alt="Remy Sharp"
                    src={thumbimage}
                    sx={{ "--Avatar-size": "24px" }}
                  />
                }
                badgeInset="14%"
                sx={{ "--Badge-paddingX": "0px" }}
              >
                <Avatar variant="outlined" size="lg" src={image}></Avatar>
              </Badge>

              <Typography level="h3">
                <CryptoCurrencyFormat amount={Number(balancecoin)} />{" "}
                {code}
              </Typography>
              <Typography level="body-lg">
                <CurrencyFormat amount={Number(balance)} prefix="$" seperator={true} />
              </Typography>
            </Stack>
          </Grid>
          <Grid pb={4}>
            {" "}
            <Box
              pt={4}
              sx={{
                display: "flex",
                gap: 2,
                flexWrap: "wrap",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {[
                {
                  title: "Send",
                  path: "/send",
                  icon: <CallMadeOutlined fontSize="xl2" />,
                },
                {
                  title: "Receive",
                  path: "/receive/coin",
                  icon: <CallReceivedOutlined fontSize="xl2" />,
                },
                {
                  title: "Swap",
                  path: "/swap",
                  icon: <SwapHoriz fontSize="xl2" />,
                },
              ].map((button, index) => (
                <Stack
                  key={index}
                  direction="column"
                  spacing={1}
                  alignItems="center"
                >
                  <IconButton
                    key={button.title}
                    variant="solid"
                    size="lg"
                    color="primary"
                    sx={{ width: "50px", height: "50px", borderRadius: "50px" }}
                    onClick={() => navigate(button.path, { state: state.coin })}
                  >
                    {button.icon}
                  </IconButton>
                  <Typography>{button.title}</Typography>
                </Stack>
              ))}
            </Box>
          </Grid>
          <Divider />
          <Grid sx={{ width: "100%" }} pt={2}>
            <Activity code={code} />
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
